<template>
	<div class="Modal">
		<button class="Modal-close-button" type="button" aria-label="Close modal" @click="onClickClose">×
		</button>
		<form @submit="save">
			<h1 class="thermo">Kwaliteitscontrole</h1>
			<div class="input-container">
				<label>Datum</label>
				<DateField v-model="values.date" :minimum-allowed-date="minDate" value-format="yyyy-mm-dd"></DateField>
			</div>
			<div class="input-container">
				<label>Begintijd</label>
				<div class="time-container">
					<select v-model="values.startHour">
						<option v-for="hour in hours" :key="hour" :value="hour">{{ hour }}</option>
					</select>
					<select v-model="values.startMinute">
						<option v-for="minute in minutes" :key="minute" :value="minute">{{ minute }}</option>
					</select>
				</div>
			</div>
				<div class="input-container">
					<label>Eindtijd</label>
					<div class="time-container">
						<select v-model="values.endHour">
							<option v-for="hour in hours" :key="hour" :value="hour">{{ hour }}</option>
						</select>
						<select v-model="values.endMinute">
							<option v-for="minute in minutes" :key="minute" :value="minute">{{
									minute
								}}
							</option>
						</select>
					</div>
				</div>
				<div class="input-container">
					<label>Agent</label>
					<select v-model="values.agent_id">
						<option v-for="agent in agents" :key="agent.id" :value="agent.id + '/' + agent.display_name">{{ agent.display_name }}</option>
					</select>
				</div>
				<div class="input-container">
					<label>Notitie</label>
					<textarea v-model="values.note"></textarea>
				</div>
			<div class="button-container">
				<Button type="submit">Inplannen</Button>
			</div>
		</form>
	</div>
</template>

<script>
import Button from "@/components/Button";
import DateField from "@/components/DateField";
import ToggleField from "@/components/ToggleField";
import {client} from "@/store";
import {mapActions, mapState} from "vuex";

export default {
	components: {
		Button,
		ToggleField,
		DateField
	},

	props: {
		company: Object
	},

	data() {
		return {
			agents: [],
			values: {
				date: "",
				startHour: "",
				startMinute: "",
				endHour: "",
				endMinute: "",
				agent_id: null,
				note: ""
			},
			addressTimeout: null,
			errors: [],
			minDate: new Date()
		};
	},

	computed: {
		saveIcon() {
			return saveIcon
		},
		...mapState("auth", {
			viewer: "viewer"
		}),

		minutes() {
			return ["00", "15", "30", "45"];
		},

		hours() {
			let hours = [];
			for (var hour = 8; hour <= 17; hour++) {
				hours.push(("0" + hour).slice(-2));
			}
			return hours;
		}
	},

	methods: {
		save(event) {
			event.preventDefault();
			client.query(`mutation($id: ID!, $date: String, $start_time: String, $end_time: String, $agent_id: ID, $agent_name: String, $note: String) {
                            createQualityAppointment(id: $id, date: $date, start_time: $start_time, end_time: $end_time, agent_id: $agent_id, agent_name: $agent_name, note: $note) {
								id
							}
					}`, {
				id: this.company.id,
				date: this.values.date,
				start_time: this.values.startHour + ":" + this.values.startMinute,
				end_time: this.values.endHour + ":" + this.values.endMinute,
				agent_id: this.values.agent_id.split('/')[0],
				agent_name: this.values.agent_id.split('/')[1],
				note: this.values.note
			}).then(result => {
				if (result.createQualityAppointment.hasOwnProperty("id") === true) {
					this.$notify({
						group: "app",
						title: "Opslaan gelukt",
						type: "success",
						text: `De marketing afspraak is succesvol opgeslagen`
					});
					this.$events.emit("map/closePopup");
					this.$emit("close");
				}
			}).catch(error => {
				this.$notify({
					group: "app",
					title: "Opslaan mislukt",
					type: "error",
					text: `Er is een fout opgetreden bij het opslaan van de afspraak`
				});
			});
		},

		onClickClose() {
			this.$emit("close");
		},

		getAgents() {
			client.query(`
				query($role: String) {
					users(role: $role) {
						id
						display_name,
						role {
							constant
						}
					}
				}
			`, {
				role: "QUALITY_CONTROL"
			}).then(result => {
				this.agents = result.users;

				if(this.agents != null && this.viewer != null && this.agents.filter(agent => agent.id === this.viewer.id || agent.role.constant === "QUALITY_CONTROL").length > 0) {
					this.values.agent_id = this.viewer.id + '/' + this.viewer.display_name;
				}
			}).catch(error => {
				this.$notify({
					group: "app",
					title: "Ophalen mislukt",
					type: "error",
					text: `Er is een fout opgetreden bij het ophalen van de agents`
				});
			});
		}
	},
	mounted() {
		this.getAgents();
	}
};
</script>
<style scoped lang="scss">
	.input-container {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		margin-bottom: 16px;

		* {
			width: 50%;
		}

		::v-deep input {
			border: 2px solid #ced6dd;
			padding: 6px;
			border-radius: 5px;
			box-sizing: border-box;
			width: 100%;
			background: #ffffff;
		}

		select {
			border: 2px solid #ced6dd;
			padding: 6px;
			border-radius: 5px;
			height: 36px;
			box-sizing: border-box;
			width: 50%;
			background: #ffffff;
			min-width: 16px;
		}

		textarea {
			border: 2px solid #ced6dd;
			padding: 6px;
			border-radius: 5px;
			box-sizing: border-box;
			width: 50%;
			background: #ffffff;
		}

		.time-container {
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: space-between;
			gap: 4px;

			* {
				width: 50%;
			}
		}
	}

	.button-container {
		display: flex;
		flex-direction: row;
		justify-content: flex-end;

		Button {
			background-color: #1aae9f;
			color: #fff;
			border-radius: 5px;
			width: 50%;
			text-align: center;
			font-size: 1rem;
			padding: 8px;
			font-weight: 600;
		}
	}
</style>
